import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import React, { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { AiFillDelete } from "react-icons/ai";
import { server } from "../../../common";
import useQuickLook from "../../../quicklook/useQuickLook";
import { useSelectAccess } from "../../../store/stateFunctions";
import { Modal } from "react-bootstrap";
import { Button } from "@mui/material";

const swalalert = withReactContent(Swal);

const JobsFromIndustry = () => {
  const user = useSelectAccess("Super Admin");
  const [data, setData] = useState([]);
  const displayFile = useQuickLook();
  const [showModal, setShowModal] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("");

  useEffect(() => {
    getData();
  }, []);

  // Get
  const getData = () => {
    server
      .get("/job/getallind_job", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete
  const handleDelete = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.title} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/job/deleteind_job/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire("Deleted!", "Job has been deleted.", "success");
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // Open modal for confirmation
  const handleOpenModal = (blog, status) => {
    setSelectedBlog(blog);
    setSelectedStatus(status);
    setShowModal(true);
  };

  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedBlog(null);
    setSelectedStatus("");
  };

  // Update Status
  const updateStatus = async () => {
    try {
      await server.put(
        `/job/update_approval_status/${selectedBlog.id}`,
        { status: selectedStatus },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: user.authToken,
          },
        }
      );
      toast.success("Job Status Updated successfully");
      getData();
      handleCloseModal();
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data?.message)
        toast.error(error.response.data.message);
      else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Failed to connect to the server");
        console.log(error.message);
      }
    }
  };
  return (
    <>
      <div className="container">
        <h2 className="py-4 text-center">Jobs From Industry</h2>
        <div className="row my-3">
          <div className="col-md-4">
            <input
              type="search"
              name=""
              className="form-control"
              placeholder="Search"
              id=""
            />
          </div>
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <select className="form-control" name="" id="">
              <option value="">Latest</option>
              <option value="">Last Month</option>
              <option value="">Last Year</option>
            </select>
          </div>
        </div>
        <div className="container" style={{ overflowX: "scroll" }}>
          <table class="table table-striped border">
            <thead>
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Position</th>
                <th scope="col">Description</th>
                <th scope="col">Company Name</th>
                <th scope="col">Company Logo</th>
                <th scope="col">Job Mode</th>
                <th scope="col">Location</th>
                <th scope="col">Address</th>
                <th scope="col">Experience</th>
                <th scope="col">Skills</th>

                <th scope="col">Status</th>
                <th></th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => {
                const statusOptions = {
                  Sent: ["Reviewed"],
                  Reviewed: ["Approved"],
                  Approved: ["Post"],
                  Post: ["Rejected"],
                  Rejected: ["Approved"],
                }[item.status];
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.position}</td>
                    <td>{item.job_description}</td>
                    <td>{item.company_name}</td>
                    <td>
                      <a href={item.image} target="_blank">
                        <img width="50" height="50" src={item.image} />
                      </a>
                    </td>
                    <td>{item.job_mode}</td>
                    <td>{item.location}</td>
                    <td>{item.address}</td>
                    <td>{item.experience}</td>
                    <td>{item.skills}</td>
                    <td>{item.status}</td>
                    <td>
                      {statusOptions &&
                        statusOptions.map((option) => (
                          <button
                            key={option}
                            className="p-1 border-0 rounded-2 banner text-white"
                            onClick={() => handleOpenModal(item, option)}
                          >
                            {option}
                          </button>
                        ))}
                    </td>{" "}
                    <td>
                      <div className="btn banner text-white">
                        <AiFillDelete onClick={() => handleDelete(item)} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal for confirmation */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Status Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update the status to {selectedStatus}?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            className="ms-2"
            onClick={updateStatus}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default JobsFromIndustry;
